import React from 'react';

export function ReservationCard({ reservation, children, className = '', actions, tags }) {
  if (!reservation) {
    return <div className={`kanban-card ${className}`.trim()}>{children}</div>;
  }
  return (
    <div className={`kanban-card ${className}`.trim()}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
        <div>
          <div style={{ fontWeight: 800 }}>{reservation.name || 'Unknown Caller'}</div>
          <div className="td-mono">{reservation.phone || reservation.number || ''}</div>
        </div>
        {reservation.invoiceNo ? <span className="call-tag" style={{ fontWeight: 800 }}>Inv {reservation.invoiceNo}</span> : null}
      </div>
      {children}
      {tags ? <div className="call-tag-row">{tags}</div> : null}
      {actions ? <div className="kanban-actions">{actions}</div> : null}
    </div>
  );
}
